module.exports = __webpack_public_path__ + "15_vast_teaser.png?6728a99b148f3a9acd68f6e0fea39579";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_vast_teaser.png
// module id = 150
// module chunks = 0